var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "emd-text _color_default" },
    [
      _vm.name
        ? [_vm._v(" " + _vm._s(_vm.$t(_vm.name)) + " ")]
        : _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }